module.exports = __webpack_public_path__ + "static/media/R&R_-set-1.ebbd7d62.jpg";